var isCustomChatbotPopulated = false;

function loadEmbeddedMessagingScript(callback) {
    var config = window.salesforceChatConfig;
    if (!config || !config.bootstrapScriptUrl) return;

    // Prevent duplicate script loading
    if (document.querySelector('script[src="' + config.bootstrapScriptUrl + '"]')) {
        if (typeof callback === "function") callback();
        return;
    }

    const script = document.createElement("script");
    script.src = config.bootstrapScriptUrl;
    script.onload = callback;
    document.head.appendChild(script);
}

function initEmbeddedMessaging(onReady) {
    try {
        var config = window.salesforceChatConfig;
        if (!config) return;

        embeddedservice_bootstrap.settings.language = config.language;
        embeddedservice_bootstrap.init(
            config.orgId,
            config.deploymentName,
            config.baseUrl,
            {
                scrt2URL: config.scrt2Url
            }
        );

        // Listen for the ready event before calling onReady
        window.addEventListener('onEmbeddedMessagingReady', function () {
            if (config.personId) {
                embeddedservice_bootstrap.prechatAPI.setHiddenPrechatFields({ "personId": config.personId });
            }

            if (typeof onReady === "function") {
                onReady();
            }
        });
    } catch (err) {
        console.error('Error loading Embedded Messaging: ', err);
    }
}

function CustomChatbot() {
    this.populateInitialChatbot = true;
    this.chatbotDetailObj = {};
    this.idleTimer = {};

    // If a longer string is found in array2, the function immediately returns false. If no longer string is found in array2, the function returns true.
    this.hasLengthierString = function (array1, array2) {
        var longestString = array1[0];

        for (var i = 1; i < array1.length; i++) {
            if (array1[i].length > longestString.length) {
                longestString = array1[i];
            }
        }

        for (var j = 0; j < array2.length; j++) {
            if (array2[j].length > longestString.length) {
                return false;
            }
        }

        return true;
    }
}

CustomChatbot.prototype.displayChatbot = function (chatbotList) {
    for (var i = 0; i < chatbotList.length; i++) {
        var chatbotDetail = chatbotList[i];
        this.chatbotDetailObj = chatbotDetail;

        if (chatbotDetail.isEnabled && this.canDisplayedOnThisPage(chatbotDetail) && (typeof chatbotDetail.isABTestVisible === "undefined" || chatbotDetail.isABTestVisible)) {
            loadEmbeddedMessagingScript(function () {
                initEmbeddedMessaging(function () {
                    if (chatbotDetail.showAfter == "scroll") {
                        this.displayChatbotAfterScroll(chatbotDetail.scrollPercentage);
                    } else if (chatbotDetail.showAfter == "delay") {
                        this.displayChatbotAfterTime(chatbotDetail.delayTime);
                    } else {
                        this.displayChatbotAfterIdleTime(chatbotDetail.idleTime);
                    }
                }.bind(this));
            }.bind(this));
            break;
        }
    }
}

CustomChatbot.prototype.displayChatbotAfterTime = function (delay) {
    var self = this;
    setTimeout(function () {
        self.populateChatbot();
    }, delay * 1000);
};

CustomChatbot.prototype.displayChatbotAfterScroll = function (percentage) {
    var self = this;
    var windowHeight = window.innerHeight;
    var documentHeight = document.body.clientHeight;

    window.addEventListener('scroll', function () {
        var scrollPercentage = (window.scrollY / (documentHeight - windowHeight)) * 100;

        if (scrollPercentage >= percentage) {
            self.populateChatbot();
        }
    });
};

CustomChatbot.prototype.displayChatbotAfterIdleTime = function (idleTime) {
    var self = this;
    this.resetIdleTimer(idleTime);
    document.addEventListener('mousemove', function () {
        self.resetIdleTimer(idleTime);
    });
    document.addEventListener('keydown', function () {
        self.resetIdleTimer(idleTime);
    });
    document.addEventListener('scroll', function () {
        self.resetIdleTimer(idleTime);
    });
};

CustomChatbot.prototype.resetIdleTimer = function (idleTime) {
    var self = this;
    clearTimeout(this.idleTimer);
    this.idleTimer = setTimeout(function () {
        self.populateChatbot();
        document.removeEventListener('mousemove', function () {
            self.resetIdleTimer();
        });
        document.removeEventListener('keydown', function () {
            self.resetIdleTimer();
        });
        document.removeEventListener('scroll', function () {
            self.resetIdleTimer();
        });
    }, idleTime * 1000);
};

CustomChatbot.prototype.canDisplayedOnThisPage = function (chatbotDetail) {
    var self = this;
    var currentPageURL = window.location.pathname;

    if (chatbotDetail.pagesToBeAvoided.length === 0 && chatbotDetail.pagesToBeDisplayed.length === 0) {
        return true;
    }

    var isInAvoidedPaths = chatbotDetail.pagesToBeAvoided.includes(currentPageURL);

    if (isInAvoidedPaths) {
        return false;
    }

    var isInDisplayedPaths = chatbotDetail.pagesToBeDisplayed.includes(currentPageURL);

    if (isInDisplayedPaths) {
        return true;
    }

    var avoidedPathsMatch = [];
    chatbotDetail.pagesToBeAvoided.map(function (path) {
        if (self.matchWildcardPath(path, currentPageURL)) {
            avoidedPathsMatch[avoidedPathsMatch.length] = path;
        }
    });

    var displayedPathsMatch = [];
    chatbotDetail.pagesToBeDisplayed.map(function (path) {
        if (self.matchWildcardPath(path, currentPageURL)) {
            displayedPathsMatch[displayedPathsMatch.length] = path;
        }
    });

    if (avoidedPathsMatch.length > 0 && displayedPathsMatch.length == 0) {
        return false;
    }

    if (avoidedPathsMatch.length == 0 && displayedPathsMatch.length > 0) {
        return true;
    }

    if (avoidedPathsMatch.length == 0 && displayedPathsMatch.length == 0) {
        return true;
    }

    if (avoidedPathsMatch.length != 0 && displayedPathsMatch.length != 0) {
        return hasLengthierString(displayedPathsMatch, avoidedPathsMatch)
    }

    return true;
}

CustomChatbot.prototype.populateChatbot = function () {
    if (this.populateInitialChatbot && !isCustomChatbotPopulated) {
        embeddedservice_bootstrap.utilAPI.launchChat()
            .then(() => {
            }).catch(() => {
            }).finally(() => {
            });
        this.populateInitialChatbot = false;
        isCustomChatbotPopulated = true;
    }
};

CustomChatbot.prototype.matchWildcardPath = function (pattern, path) {
    var regexPattern = '^' + pattern.replace(/\*/g, '.*') + '$';
    var regex = new RegExp(regexPattern);
    return regex.test(path);
}
